<template>
  <section class="instructions">
    <h2 class="instructions__title">{{ title }}</h2>
    <ul class="instructions__list">
      <li
        v-for="(instruction, idx) in instructions"
        :key="idx"
        class="instructions__item"
      >
        <span class="instructions__knob"></span>{{ instruction }}
      </li>
    </ul>
  </section>
</template>

<script>
import { INSTRUCTIONS } from '@/data/game.js'

export default {
  name: 'Instructions',
  created() {
    this.title = INSTRUCTIONS.TITLE
    this.instructions = INSTRUCTIONS.INSTRUCTIONS
  },
}
</script>
